import { useContext } from 'react'
import GalleryContext from '../gallery-context'

const useGalleryTheme = () => {
  const { theme, changeTheme } = useContext(GalleryContext)

  return { theme, changeTheme }
}

export default useGalleryTheme
